import { Routes } from '@angular/router';

import { FullComponent } from './layouts/full/full.component';
import { AppBlankComponent } from './layouts/blank/blank.component';
import { ProfilePageComponent } from './profile-page/profile-page.component';

export const AppRoutes: Routes = [{
  path: '',
  component: FullComponent,
  children: [{
    path: 'settings',
    loadChildren: './settings/settings.module#SettingsModule'
  }, {
    path: 'profile',
    component: ProfilePageComponent
  }, {
    path: '',
    loadChildren: './dashboards/dashboards.module#DashboardsModule'
  }, {
    path: 'dashboard',
    loadChildren: './dashboards/dashboards.module#DashboardsModule'
  }, {
    path: 'grid-users',
    loadChildren: './users/users.module#UsersModule'
  }, {
    path: 'grid-clients',
    loadChildren: './clients/clients.module#ClientsModule'
  }, {
    path: 'grid-implants',
    loadChildren: './implants/implants.module#ImplantsModule'
  }, {
    path: 'grid-offerte',
    loadChildren: './offerte/offerte.module#OfferteModule'
  }, {
    path: 'grid-storico-movimenti',
    loadChildren: './storico-movimenti/storico-movimenti.module#StoricoMovimentiModule'
  }, {
    path: 'grid-servizi',
    loadChildren: './servizi/servizi.module#ServiziModule'
  }, {
    path: 'grid-costo-servizi',
    loadChildren: './costo-servizi/costo-servizi.module#CostoServiziModule'
  }, {
    path: 'crea-carta-ricarica',
    loadChildren: './crea-carta-ricarica/crea-carta-ricarica.module#CreaCartaRicaricaModule'
  }, {
    path: 'carte',
    loadChildren: './carte/carta.module#CartaModule'
  }, {
    path: 'ricarica-carta',
    loadChildren: './ricarica-carta/ricarica-carta.module#RicaricaCartaModule'
  }, {
    path: 'gestisci-servizi-cash',
    loadChildren: './gestisci-servizi-cash/gestisci-servizi-cash.module#GestisciServiziCashModule'
  }, {
    path: 'grid-admins',
    loadChildren: './admins/admins.module#AdminsModule'
  }, {
    path: 'operatori',
    loadChildren: './operatori/operatori.module#OperatoriModule'
  }, {
    path: 'gestione-casse-banner/:idImpianto',
    loadChildren: './gestione-casse-banner/gestione-casse-banner.module#GestioneCasseBannerModule'
  }, {
    path: 'gestione-listini/:idImpianto',
    loadChildren: './gestione-listini/gestione-listini.module#GestioneListiniModule'
  }, {
    path: 'statistiche',
    loadChildren: './statistiche-vendita-crediti/statistiche-vendita-crediti.module#StatisticheVenditaCreditiModule'
  }, {
    path: 'gestione-casse-crediti',
    loadChildren: './gestione-casse-crediti/gestione-casse-crediti.module#GestioneCasseCreditiModule'
  }, {
    path: 'material',
    loadChildren: './material-component/material.module#MaterialComponentsModule'
  }, {
    path: 'apps',
    loadChildren: './apps/apps.module#AppsModule'
  }, {
    path: 'forms',
    loadChildren: './forms/forms.module#FormModule'
  }, {
    path: 'tables',
    loadChildren: './tables/tables.module#TablesModule'
  }, {
    path: 'datatables',
    loadChildren: './datatables/datatables.module#DataTablesModule'
  }, {
    path: 'pages',
    loadChildren: './pages/pages.module#PagesModule'
  }, {
    path: 'widgets',
    loadChildren: './widgets/widgets.module#WidgetsModule'
  }, {
    path: 'charts',
    loadChildren: './charts/chartslib.module#ChartslibModule'
  },
  {
    path: 'estratto-conto-crediti',
    loadChildren: './estratto-conto-crediti/estratto-conto-crediti.module#EstrattoContoCreditiModule'
  },
  {
    path: 'cambio-impianto-carta',
    loadChildren: './cambio-impianto-carta/cambio-impianto-carta.module#CambioImpiantoCartaModule'
  },
  {
    path: 'resetta-carta',
    loadChildren: './resetta-carta/resetta-carta.module#ResettaCartaModule'
  }
  ]
}, {
  path: '',
  component: AppBlankComponent,
  children: [{
    path: 'auth',
    loadChildren: './authentication/authentication.module#AuthenticationModule'
  }]
}, {
  path: '**',
  redirectTo: 'auth/404'
}];



// WEBPACK FOOTER //
// ./src/app/app.routing.ts